import React from 'react'

import { Food, FoodImageType, FoodImage } from '../../../core/foods'
import styles from '../../styles/modules/each-item/item-image-items.module.scss'
import FileInput from '../file-input'

interface Props {
  food: Food
  foodImage: FoodImage
  id: number
  uploadFoodImage: (
    id: number,
    foodImageType: FoodImageType,
    file: File
  ) => void
}

class FoodImageForms extends React.PureComponent<Props, {}> {
  readonly state = {}
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.itemContainer}>
          <h4>フード画像</h4>
          <FileInput
            type={'file'}
            name={'thumbnailImage'}
            id={'thumbnailImage'}
            onChange={event => {
              this.props.uploadFoodImage(
                this.props.id,
                FoodImageType.ThumbnailImage,
                event.target.files.item(0)
              )
            }}
          />
        </div>
      </div>
    )
  }
}

export default FoodImageForms 